import React from 'react';
import { NumberInput, Select, Text } from '@mantine/core';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import MediaSourceField from '../../../puck/fields/MediaSourceField';
import { plainText } from '../../../utils/richTextHtml';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { useListItemReveal } from '../../../puck/fields/listItemReveal';
import HotspotPositionField from './HotspotPositionField';
import { createHotspot, hotspotGeometry, MIN_RECTANGLE_SIZE, uniqueHotspots } from './hotspotPoints';

export default function HotspotPointsField({ value, onChange }) {
  const reveal = useListItemReveal(useSelectedItemProps().selectedItem?.props?.id);
  return (
    <>
      <Text size="xs">{value?.length ? 'Cliquez sur un repère de l’image pour écrire directement dans sa fenêtre. Texte et média sont facultatifs.' : 'Ajoutez un repère : il apparaît sur l’image, puis se déplace avec « Modifier la position ».'}</Text>
      <CollapsibleListField
        reveal={reveal}
        value={value}
        onChange={(points) => onChange(uniqueHotspots(points))}
        addLabel="Ajouter un repère"
        createItem={createHotspot}
        itemTitle={(point, index) => plainText(point.title) || `Repère ${index + 1}`}
        renderItem={(point, update, index) => (
          <>
            <Select size="xs" label="Type de repère" value={point.shape || 'circle'} allowDeselect={false} data={[{ value: 'circle', label: 'Simple' }, { value: 'rectangle', label: 'Encadré' }]} onChange={(shape) => update({ shape })} />
            <HotspotPositionField point={point} index={index} />
            {['x', 'y'].map((axis) => <NumberInput key={axis} size="xs" label={`Position ${axis.toUpperCase()} (%)`} min={0} max={100} value={hotspotGeometry(point)[axis]} onChange={(value) => update({ [axis]: Number(value) })} />)}
            {point.shape === 'rectangle' && ['width', 'height'].map((dimension) => <NumberInput key={dimension} size="xs" label={dimension === 'width' ? 'Largeur (%)' : 'Hauteur (%)'} min={MIN_RECTANGLE_SIZE} max={100} value={hotspotGeometry(point)[dimension]} onChange={(value) => update({ [dimension]: Number(value) })} />)}
            <MediaSourceField value={point.media} onChange={(media) => update({ media })} allowEmbed={false} showPlayback={false} mediaFit="contain" fieldLabel="Illustration du repère" />
          </>
        )}
      />
    </>
  );
}
